import { wakeLoopRuntimeProfileIdSchema } from "../protocol/profile.js";
import { spaceRouteParamsSchema } from "./space-route-params.js";
import { z } from "zod/v4";
//#region src/schemas/http/space-board.ts
const isoDateTimeSchema = z.iso.datetime({ offset: true });
const trimmedNonEmptyStringSchema = z.string().trim().min(1);
const nullableTrimmedNonEmptyStringSchema = trimmedNonEmptyStringSchema.nullable();
const spaceBoardOutcomeSchema = z.enum([
	"replied",
	"failed",
	"stopped",
	"timed_out"
]);
const spaceBoardSpaceSchema = z.strictObject({
	id: trimmedNonEmptyStringSchema,
	name: trimmedNonEmptyStringSchema,
	purpose: nullableTrimmedNonEmptyStringSchema,
	guide: nullableTrimmedNonEmptyStringSchema
});
const spaceBoardMembersSchema = z.strictObject({
	totalCount: z.number().int().min(0),
	humanCount: z.number().int().min(0),
	agentCount: z.number().int().min(0),
	centerAgentPresent: z.boolean()
});
const spaceBoardAgentProfileSchema = z.strictObject({
	profileId: wakeLoopRuntimeProfileIdSchema,
	profileName: nullableTrimmedNonEmptyStringSchema
});
const spaceBoardRoomProjectionSchema = z.strictObject({
	space: spaceBoardSpaceSchema,
	members: spaceBoardMembersSchema,
	agentProfiles: z.array(spaceBoardAgentProfileSchema)
});
const spaceBoardWorkingExecutionSchema = spaceBoardAgentProfileSchema.extend({ startedAt: isoDateTimeSchema });
const spaceBoardRecentOutcomeSchema = spaceBoardAgentProfileSchema.extend({
	at: isoDateTimeSchema,
	outcome: spaceBoardOutcomeSchema
});
const getSpaceBoardInputSchema = spaceRouteParamsSchema;
const spaceBoardResponseSchema = z.strictObject({
	space: spaceBoardSpaceSchema,
	members: spaceBoardMembersSchema,
	workingNow: z.array(spaceBoardWorkingExecutionSchema),
	recentOutcomes: z.array(spaceBoardRecentOutcomeSchema).max(10)
});
//#endregion
export { getSpaceBoardInputSchema, spaceBoardAgentProfileSchema, spaceBoardMembersSchema, spaceBoardOutcomeSchema, spaceBoardRecentOutcomeSchema, spaceBoardResponseSchema, spaceBoardRoomProjectionSchema, spaceBoardSpaceSchema, spaceBoardWorkingExecutionSchema };

//# sourceMappingURL=space-board.js.map